import * as ambassadorWixBookingsStaffSettingsV1StaffMemberSettings from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.http.js';
import * as ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsTypes from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.types.js';
import * as ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsUniversalTypes from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getStaffMemberSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsUniversalTypes.GetStaffMemberSettingsRequest,
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsTypes.GetStaffMemberSettingsRequest,
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsUniversalTypes.GetStaffMemberSettingsResponse,
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsTypes.GetStaffMemberSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffSettingsV1StaffMemberSettings.getStaffMemberSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/staff-member-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateStaffMemberSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsUniversalTypes.UpdateStaffMemberSettingsRequest,
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsTypes.UpdateStaffMemberSettingsRequest,
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsUniversalTypes.UpdateStaffMemberSettingsResponse,
  ambassadorWixBookingsStaffSettingsV1StaffMemberSettingsTypes.UpdateStaffMemberSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffSettingsV1StaffMemberSettings.updateStaffMemberSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/staff-member-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  StaffMemberSettings as StaffMemberSettingsOriginal,
  ContactInformation as ContactInformationOriginal,
  StaffProperties as StaffPropertiesOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GetStaffMemberSettingsRequest as GetStaffMemberSettingsRequestOriginal,
  GetStaffMemberSettingsResponse as GetStaffMemberSettingsResponseOriginal,
  UpdateStaffMemberSettingsRequest as UpdateStaffMemberSettingsRequestOriginal,
  UpdateStaffMemberSettingsResponse as UpdateStaffMemberSettingsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.types.js';
